import * as THREE from "three";
import React, { useMemo, useState } from 'react';
import {const_var, params } from '../../../../../redux/reducers/reducer';
import { extrudeSettings } from '../../../../../utils/Functions';
import { MaterialTrim } from "../../../CustomMaterial";


const TrimModel = () => {

    const [trimThickness, setTrimThickness] = useState(0.05)
    const [trimLength, setTrimLength] = useState(params.p_d)
    const [regularHeight, setRegularHeight] = useState(0);
    const [overHangLeftWidth, setOverHangLeftWidth] = useState(0);
    const [overHangRightWidth, setOverHangRightWidth] = useState(0);

    const legLength = 0.3;
    const trimHeight = 0.2

    const trimOffsetHeightL = params.p_r_p / 12 * trimThickness;

    const trimOffsetHeightR = useMemo(() => {
        return (params.singleSlope && (params.freeStandingSide === "left" || params.freeStandingSide === "right")) ? -(params.p_r_p / 12) * trimThickness : (params.p_r_p / 12) * trimThickness;
    }, [params.singleSlope, params.freeStandingSide, params.p_r_p, trimThickness])

    const dynamicHeight = useMemo(() => {
        return params.singleSlope && params.freeStandingSide === "left" ? ((params.p_r_p/12)*(params.p_w)) : 0;
    }, [params.singleSlope, params.freeStandingSide, params.p_r_p, params.p_w])

    const dynamicHeightRight = useMemo(() => {
        return params.singleSlope && params.freeStandingSide === "right" ? ((params.p_r_p/12)*(params.p_w)) : 0;
    }, [params.singleSlope, params.freeStandingSide, params.p_r_p, params.p_w])

    const frontBackTrimModel = useMemo(() => {
        let model = new THREE.Shape();
        if (params.p_r_s === 1) {
            model.moveTo(-params.p_w / 2 - overHangLeftWidth + trimHeight, 0.1);
            model.lineTo(-params.p_w / 2 - overHangLeftWidth + trimHeight, const_var.roofRegularDst + trimHeight / 2);
            model.quadraticCurveTo(-params.p_w / 2 - overHangLeftWidth + trimHeight, const_var.roofRegularDst * 1.9 + (const_var.roofRegularDst * params.p_r_p / 12) / 10, -params.p_w / 2 - overHangLeftWidth + trimHeight / 2 + const_var.roofRegularDst, const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.p_r_p / 12);
            model.lineTo(0, (params.p_r_p / 12) * params.p_w / 2 + regularHeight);
            model.lineTo(params.p_w / 2 + overHangRightWidth - trimHeight / 2 - const_var.roofRegularDst, const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.p_r_p / 12);
            model.quadraticCurveTo(params.p_w / 2 + overHangRightWidth - trimHeight, const_var.roofRegularDst * 1.9 + (const_var.roofRegularDst * params.p_r_p / 12) / 10, params.p_w / 2 + overHangRightWidth - trimHeight, const_var.roofRegularDst + trimHeight / 2);
            model.lineTo(params.p_w / 2 + overHangRightWidth + 0.005 - trimHeight, 0.1);
            
            model.lineTo(params.p_w / 2 + overHangRightWidth + 0.005, 0.1);
            model.lineTo(params.p_w / 2 + overHangRightWidth, trimHeight + const_var.roofRegularDst);
            model.quadraticCurveTo(params.p_w / 2 + overHangRightWidth, trimHeight + const_var.roofRegularDst * 1.9 + (const_var.roofRegularDst * params.p_r_p / 12) / 10, params.p_w / 2 + overHangRightWidth - const_var.roofRegularDst, trimHeight + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.p_r_p / 12);
            model.lineTo(0, (params.p_r_p / 12) * params.p_w / 2 + trimHeight + regularHeight + 0.005);
            model.lineTo(-params.p_w / 2 - overHangLeftWidth + const_var.roofRegularDst, trimHeight + const_var.roofRegularDst * 2 + const_var.roofRegularDst * params.p_r_p / 12);
            model.quadraticCurveTo(-params.p_w / 2 - overHangLeftWidth, trimHeight + const_var.roofRegularDst * 1.9 + (const_var.roofRegularDst * params.p_r_p / 12) / 10, -params.p_w / 2 - overHangLeftWidth, trimHeight + const_var.roofRegularDst)
            model.lineTo(-params.p_w / 2 - overHangLeftWidth, 0.1);
            model.closePath()
        } else if (params.p_r_s === 2 || params.p_r_s === 3) {
            model.moveTo(-params.p_w / 2, 0 - dynamicHeight);
            if(!params.singleSlope) model.lineTo(0, (params.p_r_p / 12) * params.p_w / 2);
            model.lineTo(params.p_w / 2, dynamicHeightRight);
            model.lineTo(params.p_w / 2, dynamicHeightRight + trimHeight);
            if(!params.singleSlope) model.lineTo(0, (params.p_r_p / 12) * params.p_w / 2 + trimHeight);
            model.lineTo(-params.p_w / 2, trimHeight - dynamicHeight);
            model.closePath()
        }

        return model;
    }, [params.p_w, params.p_r_p, params.p_r_s, regularHeight, dynamicHeight, dynamicHeightRight, overHangLeftWidth, overHangRightWidth, params.singleSlope]);

    const leftTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-params.p_w / 2, 0);
        model.lineTo(-params.p_w / 2, 0 + trimHeight);
        model.lineTo(-params.p_w / 2 - trimThickness, 0 - trimOffsetHeightL + trimHeight);
        model.lineTo(-params.p_w / 2 - trimThickness, 0 - trimOffsetHeightL);
        model.closePath();

        return model;
    }, [params.p_w, trimOffsetHeightL, trimThickness]);

    const rightTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(params.p_w / 2, 0);
        model.lineTo(params.p_w / 2, 0 + 0.2);
        model.lineTo(params.p_w / 2 + trimThickness, 0 - trimOffsetHeightR + 0.2);
        model.lineTo(params.p_w / 2 + trimThickness, 0 - trimOffsetHeightR);
        model.closePath();

        return model;
    }, [params.p_w, trimOffsetHeightR, trimThickness]);

    useMemo(() => {
        if (params.p_r_s === 1) {
            setTrimThickness(0.25)
            setTrimLength(params.p_d + legLength + trimThickness * 2);
            setRegularHeight(const_var.roofRegularDst * 2);
            setOverHangLeftWidth(0.05);
            setOverHangRightWidth(0.05);
        } else if (params.p_r_s === 2) {
            setTrimThickness(0.2)
            setTrimLength(params.p_d + legLength + trimThickness * 2);
            setRegularHeight(0);
        } else if (params.p_r_s === 3) {
            setTrimThickness(0.2)
            setTrimLength(params.p_d + legLength + trimThickness * 2);
            setRegularHeight(0);
        }
    }, [params.p_r_s, params.p_d, trimThickness, overHangLeftWidth, overHangRightWidth])    
    
    return (
        <group name="trim-group">
            {!(params.p_r_s === 1 && params.leanStyle.front === 'gable' && params.p_w === params.leanF_p_w && params.p_h === params.leanF_p_h && params.p_r_p == params.b_l_t_r_pF) &&
                <mesh name="front-trim" position={[0 , params.p_h + 0.01 - ((params.p_r_s == 1) ? 0.13 : 0.2), params.p_d / 2 + ((params.p_r_s == 1) ? 0.52 : 0.15)]}>
                    <extrudeGeometry args={[frontBackTrimModel, extrudeSettings(trimThickness)]} />
                    <MaterialTrim visibleSection={'center'} />
                </mesh>
            }
            {!(params.p_r_s === 1 && params.leanStyle.back === 'gable' && params.p_w === params.leanB_p_w && params.p_h === params.leanB_p_h && params.p_r_p == params.b_l_t_r_pB) &&
                <mesh name="back-trim" position={[0 , params.p_h + 0.01 - ((params.p_r_s == 1) ? 0.13 : 0.2), -params.p_d / 2 - ((params.p_r_s == 1) ? 0.52 : 0.15)]}>
                    <extrudeGeometry args={[frontBackTrimModel, extrudeSettings(-trimThickness)]} />
                    <MaterialTrim visibleSection={'center'} />
                </mesh>
            }

            {(params.p_r_s === 2 || params.p_r_s === 3) &&
                <>
                    <mesh name="left-side-trim" position={[0 , params.p_h + 0.01 - (0.2) - dynamicHeight, -trimLength / 2]}>
                        <extrudeGeometry args={[leftTrimModel, extrudeSettings(params.p_d + legLength + trimThickness * 2)]} />
                        <MaterialTrim visibleSection={'center'} />
                    </mesh>
                    <mesh name="right-side-trim" position={[0 , params.p_h + 0.01 - (0.2) + dynamicHeightRight, -trimLength / 2]}>
                        <extrudeGeometry args={[rightTrimModel, extrudeSettings(params.p_d + legLength + trimThickness * 2)]} />
                        <MaterialTrim visibleSection={'center'} />
                    </mesh>
                </>
            }
        </group>
    )
}

export default TrimModel